import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import { createDisplayNameForButtonCellElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellElement } from "../../utils/getTestId";

const BOTTOM_ADDON_TEST_ID = createTestIdForButtonCellElement("bottom-addon");

export interface IButtonCellBottomAddon {}

export const ButtonCellBottomAddon: FC<
    PropsWithChildren<IButtonCellBottomAddon>
> = ({ children }): JSX.Element => {
    return <div data-tsid={BOTTOM_ADDON_TEST_ID}>{children}</div>;
};

ButtonCellBottomAddon.displayName =
    createDisplayNameForButtonCellElement("BottomAddon");

export default ButtonCellBottomAddon;
